import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f01f0896 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _4fc821c3 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _70f58e7a = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _a9133030 = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _db1d5838 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _12fc5853 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _72ea6342 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _75fd899d = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _60b3a025 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _5396319b = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _85a80660 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _1957c560 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _54cb93fb = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _b31e2a5c = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _5cfcc9ad = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _179ddb28 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _dcdd8b5c = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _1b040a4d = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _37db6360 = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _a63513bc = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _f01f0896,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _4fc821c3,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _70f58e7a,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _a9133030,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _db1d5838,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _12fc5853,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _12fc5853,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _12fc5853,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _72ea6342,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _75fd899d,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _60b3a025,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _75fd899d,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _60b3a025,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _5396319b,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _5396319b,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _5396319b,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _5396319b,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _5396319b,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _5396319b,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _5396319b,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _85a80660,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _85a80660,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _1957c560,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _54cb93fb,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _54cb93fb,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _b31e2a5c,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _5cfcc9ad,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _179ddb28,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _179ddb28,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _dcdd8b5c,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _1b040a4d,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _37db6360,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _a63513bc,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
